import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'km',
  months: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ'],
  monthsShort: [
    'មករា',
    'កុម្ភៈ',
    'មីនា',
    'មេសា',
    'ឧសភា',
    'មិថុនា',
    'កក្កដា',
    'សីហា',
    'កញ្ញា',
    'តុលា',
    'វិច្ឆិកា',
    'ធ្នូ',
  ],
  weekdays: ['ថ្ងៃ​អាទិត្យ', 'ថ្ងៃ​ចន្ទ', 'ថ្ងៃ​អង្គារ', 'ថ្ងៃ​ពុធ', 'ថ្ងៃ​ព្រហស្បតិ៍', 'ថ្ងៃ​សុក្រ', 'ថ្ងៃ​សៅរ៍'],
  weekdaysMin: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
  weekdaysShort: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd, D MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd D MMM YYYY, h:mm A',
    'llll-Y': 'ddd D MMM, h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([ម៉ោង​សកល]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([ម៉ោង​សកល]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s ឆ្នាំ​មុន' },
    M: { other: '%s ខែមុន' },
    w: { other: '%s សប្ដាហ៍​មុន' },
    d: { other: '%s ថ្ងៃ​​មុន' },
    h: { other: '%s ម៉ោង​មុន' },
    m: { other: '%s នាទី​​មុន' },
    s: { other: '%s វិនាទី​មុន' },
  },
  future: {
    y: { other: '%s ឆ្នាំទៀត' },
    M: { other: '%s ខែទៀត' },
    w: { other: '%s សប្ដាហ៍ទៀត' },
    d: { other: '%s ថ្ងៃទៀត' },
    h: { other: '%s ម៉ោងទៀត' },
    m: { other: '%s នាទីទៀត' },
    s: { other: '%s វិនាទីទៀត' },
  },
  pastLong: {
    y: { other: '%s ឆ្នាំ​មុន' },
    M: { other: '%s ខែមុន' },
    w: { other: '%s សប្ដាហ៍​មុន' },
    d: { other: '%s ថ្ងៃ​មុន' },
    h: { other: '%s ម៉ោង​មុន' },
    m: { other: '%s នាទី​មុន' },
    s: { other: '%s វិនាទី​មុន' },
  },
  futureLong: {
    y: { other: '%s ឆ្នាំទៀត' },
    M: { other: '%s ខែទៀត' },
    w: { other: '%s សប្ដាហ៍ទៀត' },
    d: { other: '%s ថ្ងៃទៀត' },
    h: { other: 'ក្នុង​រយៈ​ពេល %s ម៉ោង' },
    m: { other: '%s នាទីទៀត' },
    s: { other: '%s វិនាទីទៀត' },
  },
  abbr: {
    y: { other: '%s ឆ្នាំ' },
    M: { other: '%s ខែ' },
    w: { other: '%s សប្ដាហ៍' },
    d: { other: '%s ថ្ងៃ' },
    h: { other: '%s ម៉ោង' },
    m: { other: '%s នាទី' },
    s: { other: '%s វិនាទី' },
  },
  full: {
    y: { other: '%s ឆ្នាំ' },
    M: { other: '%s ខែ' },
    w: { other: '%s សប្ដាហ៍' },
    d: { other: '%s ថ្ងៃ' },
    h: { other: '%s ម៉ោង' },
    m: { other: '%s នាទី' },
    s: { other: '%s វិនាទី' },
  },
  justNow: 'អម្បាញ់​មិញ',
  yesterday: 'ម្សិល​មិញ',
  today: 'ថ្ងៃនេះ',
  tomorrow: 'ថ្ងៃស្អែក',
  weekStart: 0,
  timeRange: '%$1s - %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'MMMM D', end: 'D MMMM YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd DD-MM-YYYY', end: 'ddd DD MMM YYYY' },
    'Y-1': { start: 'ddd DD MMM YYYY', end: 'ddd DD MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([ម៉ោង​សកល]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([ម៉ោង​សកល]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([ម៉ោង​សកល]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([ម៉ោង​សកល]Z)' },
  },
};
const localeName: LocaleName = 'km';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
